import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { HttpCancelService } from '../services/http-cancel.service';

export const httpCancelInterceptor: HttpInterceptorFn = (req, next) => {
  const httpCancelService = inject(HttpCancelService);
  return next(req).pipe(takeUntil(httpCancelService.onCancelPendingRequests()));
};
